import { NgModule } from '@angular/core';

import { GroupComponent } from './group.component';

/**
 *  @deprecated use GroupComponent
 */
@NgModule({
  imports: [GroupComponent],
  exports: [GroupComponent],
})
export class GroupModule {}
export { GroupComponent } from './group.component';
